import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _lang, _configs;
import './index.css';
import i18next from 'i18next';
import * as lib_config from '@clearscore-group/lib.config.i18n';
import { EN_GB, EN_ZA, EN_AU, GB, ZA, AU, CA, NZ } from '@clearscore-group/lib.config.i18n';
import React, { Fragment } from 'react';
import Logo from '@clearscore/rainbow.icons.clearscore-logo-wordmark';
import Text from '@clearscore/ui.rainbow.text';
import { useTranslation, Trans } from 'react-i18next';
import useMarketConfig from '@clearscore-group/lib.hooks.use-market-config-deprecated';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as reactRedux$1 from 'react-redux';
import ' @babel/runtime/helpers/objectSpread2';
import _objectSpread$1 from ' @babel/runtime/helpers/objectSpread2';
import useWebsiteTracking$2 from '@clearscore-group/lib.hooks.use-website-tracking';
import Spacer from '@clearscore/ui.rainbow.spacer';
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var a = Object.defineProperty({}, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function get() {
        return n[k];
      }
    });
  });
  return a;
}
function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
  /* global define */

  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }
      return classes.join(' ');
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var styles$3 = {
  "image": "image--i2fcN",
  "contained": "contained--zTVdz",
  "stretched": "stretched--A-2P-",
  "rounded": "rounded--yDGQA"
};
var Image = function Image(_ref) {
  var _classnames;
  var src = _ref.src,
    sources = _ref.sources,
    _ref$alt = _ref.alt,
    _alt = _ref$alt === void 0 ? '' : _ref$alt,
    title = _ref.title,
    _ref$rounded = _ref.rounded,
    _rounded = _ref$rounded === void 0 ? false : _ref$rounded,
    _ref$contained = _ref.contained,
    _contained = _ref$contained === void 0 ? false : _ref$contained,
    _ref$stretched = _ref.stretched,
    _stretched = _ref$stretched === void 0 ? false : _ref$stretched,
    loading = _ref.loading,
    onLoad = _ref.onLoad,
    fallbackSrc = _ref.fallbackSrc;
  var imageClassnames = classnames(styles$3.image, (_classnames = {}, _defineProperty(_classnames, styles$3.contained, _contained), _defineProperty(_classnames, styles$3.stretched, _stretched), _defineProperty(_classnames, styles$3.rounded, _rounded), _classnames));
  var image = /*#__PURE__*/React.createElement("img", {
    className: imageClassnames,
    src: src,
    alt: _alt,
    title: title,
    loading: loading,
    onLoad: onLoad,
    onError: function onError(e) {
      if (fallbackSrc && e.target instanceof HTMLImageElement && e.target.src !== fallbackSrc) {
        e.target.onerror = null;
        e.target.src = fallbackSrc;
      }
    }
  });
  if (sources) {
    return /*#__PURE__*/React.createElement("picture", null, sources.map(function (source, i) {
      return /*#__PURE__*/React.createElement("source", _objectSpread({
        key: i,
        "data-qa": "source"
      }, source));
    }), image);
  }
  return image;
};
var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }
  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var cjs$8 = deepmerge_1;
function _interopDefaultLegacy$6(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _objectSpread__default$4 = /*#__PURE__*/_interopDefaultLegacy$6(_objectSpread$1);

/**
 * Create an action object
 * @param {String} type Name of Redux action
 * @param {*} payload action payload
 * @return {{ type: string, payload?: any }} flux action format object
 */
function createAction(type, payload) {
  return _objectSpread__default$4['default']({
    type: type
  }, payload && {
    payload: payload
  });
}
var _default$6 = createAction;
var cjs$7 = /*#__PURE__*/Object.defineProperty({
  default: _default$6
}, '__esModule', {
  value: true
});
function _interopDefaultLegacy$5(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _objectSpread__default$3 = /*#__PURE__*/_interopDefaultLegacy$5(_objectSpread$1);
function createRequestPayload(client, url) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';
  var data = arguments.length > 3 ? arguments[3] : undefined;
  var meta = arguments.length > 4 ? arguments[4] : undefined;
  var headers = arguments.length > 5 ? arguments[5] : undefined;
  var timeout = arguments.length > 6 ? arguments[6] : undefined;
  var _ref2 = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {},
    params = _ref2.params;
  return {
    request: _objectSpread__default$3['default'](_objectSpread__default$3['default'](_objectSpread__default$3['default'](_objectSpread__default$3['default'](_objectSpread__default$3['default']({
      client: client,
      url: url,
      method: method
    }, data && {
      data: data
    }), meta && {
      meta: meta
    }), headers && {
      headers: headers
    }), timeout && {
      timeout: timeout
    }), params && {
      params: params
    })
  };
}
var _default$5 = createRequestPayload;
var cjs$6 = /*#__PURE__*/Object.defineProperty({
  default: _default$5
}, '__esModule', {
  value: true
});
function _interopDefaultLegacy$4(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _objectSpread__default$2 = /*#__PURE__*/_interopDefaultLegacy$4(_objectSpread$1);

/**
 * Given an single pathref, resolve to the value of the given data object
 * @param {string} pathArr single property path
 * @param {object} obj object of data to resolve
 * @returns {object} object containing resolved data
 */
function resolveProp(pathArr, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return resolveProp(pathArr, objHolder);
    };
  }
  if (obj === null || obj === undefined) {
    return undefined;
  }
  var willReturn = obj;
  var counter = 0;
  var pathArrValue = typeof pathArr === 'string' ? pathArr.split('.') : pathArr;
  while (counter < pathArrValue.length) {
    if (willReturn === null || willReturn === undefined) {
      return undefined;
    }
    willReturn = willReturn[pathArrValue[counter]];
    counter += 1;
  }
  return willReturn;
}

/**
 * Given an object of object property paths and an object, resolves the paths to the values in the object
 * @param {object} paths object of property paths
 * @param {object} data object of data to resolve
 * @returns {object} object containing resolved data
 */

function resolveProps(paths, data) {
  return Object.keys(paths).reduce(function (resolvedData, prop) {
    var pathRef = paths[prop];
    return _objectSpread__default$2['default'](_objectSpread__default$2['default']({}, resolvedData), {}, _defineProperty({}, prop, resolveProp(pathRef, data)));
  }, {});
}
var _default$4 = resolveProps;
var resolveProp_1 = resolveProp;
var cjs$5 = /*#__PURE__*/Object.defineProperty({
  default: _default$4,
  resolveProp: resolveProp_1
}, '__esModule', {
  value: true
});
var index$1 = function index$1() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
var _default$3 = index$1;
var cjs$4 = /*#__PURE__*/Object.defineProperty({
  default: _default$3
}, '__esModule', {
  value: true
});
function _interopDefaultLegacy$3(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var canUseDom__default$1 = /*#__PURE__*/_interopDefaultLegacy$3(cjs$4);
var CACHE_NAME = '__cs__';
var LOCAL_NAMESPACE = 'local';
var RESET_MARKET_ENVS = {
  local: {}
};

/**
 * Returns an env after providing a object path
 * @param path
 * @return {*}
 */

function getSingleEnv(path) {
  if (!canUseDom__default$1['default']()) return ''; // @todo: [PM] get envs on the server
  var envs;
  if (window[CACHE_NAME] && window[CACHE_NAME].env) {
    envs = window[CACHE_NAME].env;
  } else {
    envs = window.env;
  }
  return cjs$5.resolveProp("".concat(LOCAL_NAMESPACE, ".").concat(path), envs) || cjs$5.resolveProp(path, envs);
}
var getEnvs = function getEnvs() {
  if (!canUseDom__default$1['default']()) return '';
  return window[CACHE_NAME].env || window.env;
};

/**
 * Set envs
 * @param envs - new market envs
 * @return void
 */

var setEnvs = function setEnvs() {
  var envs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (window[CACHE_NAME] && window[CACHE_NAME].env) {
    window[CACHE_NAME].env = Object.assign(window[CACHE_NAME].env, envs);
  } else {
    window.env = Object.assign(window.env, envs);
  }
};

/**
 * Returns an env after providing a object path or array of multiple object paths
 * @param paths
 * @return {*}
 */

function getEnv(paths) {
  if (Array.isArray(paths)) {
    return paths.map(function (path) {
      return getSingleEnv(path);
    });
  }
  return getSingleEnv(paths);
}
var RESET_MARKET_ENVS_1 = RESET_MARKET_ENVS;
var _default$2 = getEnv;
var getEnvs_1 = getEnvs;
var setEnvs_1 = setEnvs;
var cjs$3 = /*#__PURE__*/Object.defineProperty({
  RESET_MARKET_ENVS: RESET_MARKET_ENVS_1,
  default: _default$2,
  getEnvs: getEnvs_1,
  setEnvs: setEnvs_1
}, '__esModule', {
  value: true
});
var INITIAL = 'initial';
var SUCCESS = 'success';
var ERROR = 'error';
var PENDING = 'pending';
var src = /*#__PURE__*/Object.freeze({
  __proto__: null,
  INITIAL: INITIAL,
  SUCCESS: SUCCESS,
  ERROR: ERROR,
  PENDING: PENDING
});

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */
var parse_1 = parse;
var serialize_1 = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }
  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }
    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }
  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;
  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }
  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }
  var value = enc(val);
  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }
  var str = name + '=' + value;
  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid');
    }
    str += '; Max-Age=' + Math.floor(maxAge);
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += '; Domain=' + opt.domain;
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += '; Path=' + opt.path;
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += '; Expires=' + opt.expires.toUTCString();
  }
  if (opt.httpOnly) {
    str += '; HttpOnly';
  }
  if (opt.secure) {
    str += '; Secure';
  }
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}
var cookie = {
  parse: parse_1,
  serialize: serialize_1
};
function _interopDefaultLegacy$2(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _objectSpread__default$1 = /*#__PURE__*/_interopDefaultLegacy$2(_objectSpread$1);
var cookie__default = /*#__PURE__*/_interopDefaultLegacy$2(cookie);
var getEnvs__default = /*#__PURE__*/_interopDefaultLegacy$2(cjs$3);
var canUseDom__default = /*#__PURE__*/_interopDefaultLegacy$2(cjs$4);
var hasDocumentCookie = function hasDocumentCookie() {
  return canUseDom__default['default']() && 'cookie' in window.document;
};

// if it looks like JSON, we'll treat it like JSON
var isParsingCookie = function isParsingCookie() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value[0] === '{' || value[0] === '[' || value[0] === '"';
};
var readCookie = function readCookie(value) {
  if (isParsingCookie(value)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // at least we tried
    }
  }
  return value;
};
var getDefaultOptions = function getDefaultOptions() {
  return _objectSpread__default$1['default'](_objectSpread__default$1['default']({}, getEnvs__default['default']('COOKIE_DOMAIN') && {
    domain: getEnvs__default['default']('COOKIE_DOMAIN')
  }), {}, {
    path: '/',
    secure: true
  });
};

/**
 * set cookie
 * @param {string} cookieName
 * @param {any} payload
 * @param {object} options
 */
var setCookie$1 = function setCookie$1(cookieName, payload, options) {
  var cookieValue = typeof payload === 'object' ? JSON.stringify(payload) : payload;
  if (hasDocumentCookie()) {
    document.cookie = cookie__default['default'].serialize(cookieName, cookieValue, _objectSpread__default$1['default'](_objectSpread__default$1['default']({}, getDefaultOptions()), options));
  }
};

/**
 * get cookie
 * @param {string} cookieName
 */
var getCookie$1 = function getCookie$1(cookieName) {
  if (hasDocumentCookie()) {
    var _document$cookie;
    var cookieValue = cookie__default['default'].parse((_document$cookie = document.cookie) !== null && _document$cookie !== void 0 ? _document$cookie : '')[cookieName];
    return readCookie(cookieValue);
  }
  return null;
};

/**
 * get all cookies
 */
var getAllCookies$1 = function getAllCookies$1() {
  if (hasDocumentCookie()) {
    var _document$cookie2;
    var allCookies = cookie__default['default'].parse((_document$cookie2 = document.cookie) !== null && _document$cookie2 !== void 0 ? _document$cookie2 : '');
    return Object.entries(allCookies).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        cookieKey = _ref4[0],
        cookieValue = _ref4[1];
      return _objectSpread__default$1['default'](_objectSpread__default$1['default']({}, acc), {}, _defineProperty({}, cookieKey, readCookie(cookieValue)));
    }, {});
  }
  return null;
};

/**
 * deletes cookie
 * @param {string} cookieName
 */
var removeCookie$1 = function removeCookie$1(cookieName) {
  if (hasDocumentCookie()) {
    var options = _objectSpread__default$1['default'](_objectSpread__default$1['default']({}, getDefaultOptions()), {}, {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    document.cookie = cookie__default['default'].serialize(cookieName, '', options);
  }
};
var CS_SESSION_COOKIE = getEnvs__default['default']('SESSION_COOKIE') || 'CS_SESSION';
var CS_PERSON_COOKIE = 'CS_PERSON';
var CS_PUBLISHER_ID = 'CS_PUBLISHER_ID';
var VISITED_SITE_COOKIE_NAME = 'CS_VISITED_SITE';
// Please note this is concatenated with `alertId` to give full cookie key
var CS_ALERT_VIEWED_COOKIE_PREFIX = 'CS_ALERT_VIEWED';
var CS_CURRENT_LANGUAGE = 'CS_CURRENT_LANGUAGE';

// Expiry (in milliseconds)
var EXPIRE_3DAYS = 259200000;
var consts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CS_SESSION_COOKIE: CS_SESSION_COOKIE,
  CS_PERSON_COOKIE: CS_PERSON_COOKIE,
  CS_PUBLISHER_ID: CS_PUBLISHER_ID,
  VISITED_SITE_COOKIE_NAME: VISITED_SITE_COOKIE_NAME,
  CS_ALERT_VIEWED_COOKIE_PREFIX: CS_ALERT_VIEWED_COOKIE_PREFIX,
  CS_CURRENT_LANGUAGE: CS_CURRENT_LANGUAGE,
  EXPIRE_3DAYS: EXPIRE_3DAYS
});

/**
 * Directly set the publisher cookie to `body` with no validation
 */
var setPublisherCookieValue = function setPublisherCookieValue(body) {
  return setCookie$1(CS_PUBLISHER_ID, body, {
    expires: new Date(Date.now() + EXPIRE_3DAYS)
  });
};

/**
 * Sets the CS_PUBLISHER_ID cookie if utm_source + utm_medium is present in search params
 * @param {String} searchParams
 */
var setPublisherCookie$1 = function setPublisherCookie$1() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var urlParams = new URLSearchParams(searchParams);
  var publisherId = urlParams.get('utm_source');
  var transactionId = urlParams.get('utm_medium');
  var campaignId = urlParams.get('utm_campaign');
  if (publisherId && transactionId) {
    setPublisherCookieValue(_objectSpread__default$1['default']({
      publisherId: publisherId,
      transactionId: transactionId
    }, campaignId && {
      campaignId: campaignId
    }));
  }
};

/**
 * Returns CS_PUBLISHER_ID cookie or {} if it does not exist
 */
var getPublisherCookie$1 = function getPublisherCookie$1() {
  return getCookie$1(CS_PUBLISHER_ID) || {};
};

/**
 * Returns CS_PUBLISHER_ID cookie (if present) as the original map
 * of `utm_xxx` to value as opposed to the mappings above (`publisherId` etc.)
 */
var getPublisherCookieUTM$1 = function getPublisherCookieUTM$1() {
  var _getPublisherCookie$ = getPublisherCookie$1(),
    publisherId = _getPublisherCookie$.publisherId,
    transactionId = _getPublisherCookie$.transactionId,
    campaignId = _getPublisherCookie$.campaignId,
    sentToBackend = _getPublisherCookie$.sentToBackend;
  if (!publisherId || !transactionId) {
    return {};
  }
  return _objectSpread__default$1['default'](_objectSpread__default$1['default']({
    utm_source: publisherId,
    utm_medium: transactionId
  }, campaignId && {
    utm_campaign: campaignId
  }), sentToBackend && {
    sentToBackend: sentToBackend
  });
};

/**
 * Check if a given publisher cookie has been sent to the backend
 * @param {Object} publisherCookie Publisher cookie as returned from `getPublisherCookie`
 */
var publisherCookieIsSentToBackend$1 = function publisherCookieIsSentToBackend$1(publisherCookie) {
  return !!publisherCookie.sentToBackend;
};

/**
 * Mark the publisher cookie as "sent to the backend" so we can avoid sending it again
 */
var markPublisherCookieAsSentToBackend$1 = function markPublisherCookieAsSentToBackend$1() {
  var pubCookie = getPublisherCookie$1();
  if (Object.entries(pubCookie).length > 0 && !publisherCookieIsSentToBackend$1(pubCookie)) {
    setPublisherCookieValue(_objectSpread__default$1['default'](_objectSpread__default$1['default']({}, pubCookie), {}, {
      sentToBackend: true
    }));
  }
};
var second$1 = 1000;
var minute$1 = second$1 * 60;
var thirtyMinutes = minute$1 * 30;
var setPersonCookie$1 = function setPersonCookie$1(personIdentifier) {
  setCookie$1(CS_PERSON_COOKIE, personIdentifier, {
    expires: new Date(new Date().getTime() + thirtyMinutes)
  });
};
var getPersonCookie$1 = function getPersonCookie$1() {
  return getCookie$1(CS_PERSON_COOKIE);
};
var removePersonCookie$1 = function removePersonCookie$1() {
  return removeCookie$1(CS_PERSON_COOKIE);
};
var second = 1000;
var minute = second * 60;
var hour = minute * 60;
var day = hour * 24;
var oneYear = day * 365;
var setVisitedSiteCookie$1 = function setVisitedSiteCookie$1(userIdentifier) {
  setCookie$1(VISITED_SITE_COOKIE_NAME, userIdentifier, {
    expires: new Date(new Date().getTime() + oneYear)
  });
};
var getVisitedSiteCookie$1 = function getVisitedSiteCookie$1() {
  return getCookie$1(VISITED_SITE_COOKIE_NAME);
};
var removeVisitedSiteCookie$1 = function removeVisitedSiteCookie$1() {
  return removeCookie$1(VISITED_SITE_COOKIE_NAME);
};

// needed for the remember-me checkbox on login
// work around since you can not use JS APIs to calculate if a cookie has 'expires' set
// We create a session with 'expires', then when changing language, or refreshing a token, we update the cookie.
// except, 'updating' cookies is impossible, so we need to cache the unreachable properties of the cookie
var CS_SESSION_EXPIRES = 'CS_SESSION_EXPIRES';
var setExpires = function setExpires(expiresDate) {
  window[CS_SESSION_EXPIRES] = expiresDate;
};
var getExpires = function getExpires() {
  return window[CS_SESSION_EXPIRES];
};

/**
 * Sets the session cookie
 * @param session.sessionToken
 * @param session.accountId
 * @param session.username
 * @param session.market
 * @todo SESSION - remove old auth flow when LLT/2FA is live
 */
var setSessionCookie$1 = function setSessionCookie$1(_ref5) {
  var market = _ref5.market,
    access_token = _ref5.access_token,
    refresh_token = _ref5.refresh_token,
    session_id = _ref5.session_id,
    remember = _ref5.remember,
    o_token = _ref5.o_token,
    locale = _ref5.locale;
  var expiresDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  setExpires(remember ? expiresDate : undefined);
  setCookie$1(CS_SESSION_COOKIE, _objectSpread__default$1['default']({
    access_token: access_token,
    refresh_token: refresh_token,
    session_id: session_id,
    o_token: o_token,
    market: market.toLowerCase()
  }, locale ? {
    locale: locale
  } : {}), _objectSpread__default$1['default']({}, remember && {
    expires: getExpires()
  }));
};
/* eslint-enable camelcase */

/**
 * Update the session cookie
 */
var updateSessionCookie$1 = function updateSessionCookie$1(data) {
  var cookie = getCookie$1(CS_SESSION_COOKIE);
  setSessionCookie$1(_objectSpread__default$1['default'](_objectSpread__default$1['default'](_objectSpread__default$1['default']({}, cookie), data), {}, {
    remember: !!getExpires()
  }));
};

/**
 * Get the session cookie
 */
var getSessionCookie$1 = function getSessionCookie$1() {
  return getCookie$1(CS_SESSION_COOKIE);
};

/**
 * Removes the session cookie
 */
var removeSessionCookie$1 = function removeSessionCookie$1() {
  removeCookie$1(CS_SESSION_COOKIE);
};
var getKeyForAlertId = function getKeyForAlertId(alertId) {
  return "".concat(CS_ALERT_VIEWED_COOKIE_PREFIX, "_").concat(alertId.toUpperCase());
};
var setAlertCookie$1 = function setAlertCookie$1(alertId, alertCooldown) {
  var key = getKeyForAlertId(alertId);
  setCookie$1(key, true, {
    expires: new Date(Date.now() + alertCooldown)
  });
};
var getAlertCookie$1 = function getAlertCookie$1(alertId) {
  return getCookie$1(getKeyForAlertId(alertId)) || null;
};
var hasCookieForAlert$1 = function hasCookieForAlert$1(alertId) {
  return getAlertCookie$1(alertId) !== null;
};
var getAllCookies = getAllCookies$1;
var setCookie = setCookie$1;
var getCookie = getCookie$1;
var removeCookie = removeCookie$1;
var getPersonCookie = getPersonCookie$1;
var setPersonCookie = setPersonCookie$1;
var removePersonCookie = removePersonCookie$1;
var getVisitedSiteCookie = getVisitedSiteCookie$1;
var setVisitedSiteCookie = setVisitedSiteCookie$1;
var removeVisitedSiteCookie = removeVisitedSiteCookie$1;
var getPublisherCookie = getPublisherCookie$1;
var setPublisherCookie = setPublisherCookie$1;
var getPublisherCookieUTM = getPublisherCookieUTM$1;
var publisherCookieIsSentToBackend = publisherCookieIsSentToBackend$1;
var markPublisherCookieAsSentToBackend = markPublisherCookieAsSentToBackend$1;
var setSessionCookie = setSessionCookie$1;
var getSessionCookie = getSessionCookie$1;
var updateSessionCookie = updateSessionCookie$1;
var removeSessionCookie = removeSessionCookie$1;
var getAlertCookie = getAlertCookie$1;
var setAlertCookie = setAlertCookie$1;
var hasCookieForAlert = hasCookieForAlert$1;
var constants$1 = consts;
var constants_1$1 = constants$1;
var getAlertCookie_1 = getAlertCookie;
var getAllCookies_1 = getAllCookies;
var getCookie_1 = getCookie;
var getPersonCookie_1 = getPersonCookie;
var getPublisherCookie_1 = getPublisherCookie;
var getPublisherCookieUTM_1 = getPublisherCookieUTM;
var getSessionCookie_1 = getSessionCookie;
var getVisitedSiteCookie_1 = getVisitedSiteCookie;
var hasCookieForAlert_1 = hasCookieForAlert;
var markPublisherCookieAsSentToBackend_1 = markPublisherCookieAsSentToBackend;
var publisherCookieIsSentToBackend_1 = publisherCookieIsSentToBackend;
var removeCookie_1 = removeCookie;
var removePersonCookie_1 = removePersonCookie;
var removeSessionCookie_1 = removeSessionCookie;
var removeVisitedSiteCookie_1 = removeVisitedSiteCookie;
var setAlertCookie_1 = setAlertCookie;
var setCookie_1 = setCookie;
var setPersonCookie_1 = setPersonCookie;
var setPublisherCookie_1 = setPublisherCookie;
var setSessionCookie_1 = setSessionCookie;
var setVisitedSiteCookie_1 = setVisitedSiteCookie;
var updateSessionCookie_1 = updateSessionCookie;
var cjs$2 = /*#__PURE__*/Object.defineProperty({
  constants: constants_1$1,
  getAlertCookie: getAlertCookie_1,
  getAllCookies: getAllCookies_1,
  getCookie: getCookie_1,
  getPersonCookie: getPersonCookie_1,
  getPublisherCookie: getPublisherCookie_1,
  getPublisherCookieUTM: getPublisherCookieUTM_1,
  getSessionCookie: getSessionCookie_1,
  getVisitedSiteCookie: getVisitedSiteCookie_1,
  hasCookieForAlert: hasCookieForAlert_1,
  markPublisherCookieAsSentToBackend: markPublisherCookieAsSentToBackend_1,
  publisherCookieIsSentToBackend: publisherCookieIsSentToBackend_1,
  removeCookie: removeCookie_1,
  removePersonCookie: removePersonCookie_1,
  removeSessionCookie: removeSessionCookie_1,
  removeVisitedSiteCookie: removeVisitedSiteCookie_1,
  setAlertCookie: setAlertCookie_1,
  setCookie: setCookie_1,
  setPersonCookie: setPersonCookie_1,
  setPublisherCookie: setPublisherCookie_1,
  setSessionCookie: setSessionCookie_1,
  setVisitedSiteCookie: setVisitedSiteCookie_1,
  updateSessionCookie: updateSessionCookie_1
}, '__esModule', {
  value: true
});
function defaultEqualityCheck(a, b) {
  return a === b;
}
function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }
  return true;
}
function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }
    lastArgs = arguments;
    return lastResult;
  };
}
function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }
  return dependencies;
}
function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }
    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;
      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}
var createSelector = createSelectorCreator(defaultMemoize);
function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }
    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}
var es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultMemoize: defaultMemoize,
  createSelectorCreator: createSelectorCreator,
  createSelector: createSelector,
  createStructuredSelector: createStructuredSelector
});
var requestStatuses = /*@__PURE__*/getAugmentedNamespace(src);
function _interopNamespace$1(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}
var requestStatuses__namespace$1 = /*#__PURE__*/_interopNamespace$1(requestStatuses);
var getRequestStatus = function getRequestStatus(status, statusCode) {
  return {
    isInitial: status === requestStatuses__namespace$1.INITIAL,
    isPending: status === requestStatuses__namespace$1.PENDING,
    isComplete: status === requestStatuses__namespace$1.SUCCESS,
    hasFailed: status === requestStatuses__namespace$1.ERROR,
    statusCode: statusCode
  };
};
var calculateIsCompleteMultiple = function calculateIsCompleteMultiple(statusList) {
  if (statusList.every(function (status) {
    return status === requestStatuses__namespace$1.SUCCESS;
  })) return true;
  if (statusList.every(function (status) {
    return status === requestStatuses__namespace$1.ERROR;
  })) return false;
  return statusList.map(function (status) {
    return status === requestStatuses__namespace$1.SUCCESS || status === requestStatuses__namespace$1.ERROR;
  }).every(Boolean);
};
var getRequestStatusMultiple = function getRequestStatusMultiple() {
  var statusList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var statusCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hasStatuses = statusList.length;
  return {
    isInitial: hasStatuses ? statusList.every(function (status) {
      return status === requestStatuses__namespace$1.INITIAL;
    }) : true,
    isPending: statusList.some(function (status) {
      return status === requestStatuses__namespace$1.PENDING;
    }),
    isComplete: hasStatuses ? calculateIsCompleteMultiple(statusList) : false,
    hasFailed: hasStatuses ? statusList.every(function (status) {
      return status === requestStatuses__namespace$1.ERROR;
    }) : false,
    hasFailures: statusList.some(function (status) {
      return status === requestStatuses__namespace$1.ERROR;
    }),
    statusCodes: statusCodes
  };
};
var index = function index(state, prop) {
  var props = prop.split('.');
  var hasValidRootReducer = props.length === 1 ? state : state[props[0]];
  if (hasValidRootReducer) {
    return cjs$5.resolveProp(prop, state) || requestStatuses__namespace$1.INITIAL;
  }
  console.error("Cannot resolve root state for prop: ".concat(prop)); // eslint-disable-line no-console
  return requestStatuses__namespace$1.ERROR;
};
var _default$1 = index;
var getRequestStatus_1 = getRequestStatus;
var getRequestStatusMultiple_1 = getRequestStatusMultiple;
var cjs$1 = /*#__PURE__*/Object.defineProperty({
  default: _default$1,
  getRequestStatus: getRequestStatus_1,
  getRequestStatusMultiple: getRequestStatusMultiple_1
}, '__esModule', {
  value: true
});
var lib_config_i18n = /*@__PURE__*/getAugmentedNamespace(lib_config);
var reselect = /*@__PURE__*/getAugmentedNamespace(es);
function _interopDefaultLegacy$1(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy$1(_objectSpread$1);
var createAction__default = /*#__PURE__*/_interopDefaultLegacy$1(cjs$7);
var createRequestPayload__default = /*#__PURE__*/_interopDefaultLegacy$1(cjs$6);
var getEnv__default = /*#__PURE__*/_interopDefaultLegacy$1(cjs$3);
var requestStatuses__namespace = /*#__PURE__*/_interopNamespace(requestStatuses);
var resolveRequest__default = /*#__PURE__*/_interopDefaultLegacy$1(cjs$1);

/* eslint-disable import/prefer-default-export */

/**
 * Get the app version from querystring if running in webview
 * context (to be passed eventually to segmenter)
 */
var getWebviewAppVersion = function getWebviewAppVersion() {
  var _window$location;
  if (!getEnv__default['default']('WEBVIEW')) return null;
  return new URLSearchParams((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.search).get('appVersion');
};
var MARKET = 'CS/MARKET';
var MARKET_SET_MARKETS = "".concat(MARKET, "_SET_MARKETS");
var MARKET_SET_LOCALES = "".concat(MARKET, "_SET_LOCALES");
var MARKET_SET_ENVS = "".concat(MARKET, "_SET_ENVS");
var MARKET_SET_ACTIVE_MARKET = "".concat(MARKET, "_SET_ACTIVE_MARKET");
var MARKET_SET_ACTIVE_LOCALE = "".concat(MARKET, "_SET_ACTIVE_LOCALE");
var MARKET_FETCH_CONFIG = "".concat(MARKET, "_FETCH_CONFIG");
var MARKET_FETCH_CONFIG_PENDING = "".concat(MARKET, "_FETCH_CONFIG_PENDING");
var MARKET_FETCH_CONFIG_SUCCESS = "".concat(MARKET_FETCH_CONFIG, "_SUCCESS");
var MARKET_FETCH_CONFIG_ERROR = "".concat(MARKET_FETCH_CONFIG, "_ERROR");
var MARKET_FETCH_STATIC_CONFIG = "".concat(MARKET, "_FETCH_STATIC_CONFIG");
var MARKET_FETCH_STATIC_CONFIG_SUCCESS = "".concat(MARKET_FETCH_STATIC_CONFIG, "_SUCCESS");
var MARKET_FETCH_STATIC_CONFIG_ERROR = "".concat(MARKET_FETCH_STATIC_CONFIG, "_ERROR");
var setMarkets = function setMarkets(markets) {
  return {
    type: MARKET_SET_MARKETS,
    payload: markets
  };
};
var setLocales = function setLocales(locales) {
  return {
    type: MARKET_SET_LOCALES,
    payload: locales
  };
};
var setMarketsEnvs = function setMarketsEnvs(envs) {
  return {
    type: MARKET_SET_ENVS,
    payload: envs
  };
};
var setActiveMarket = function setActiveMarket(market) {
  return createAction__default['default'](MARKET_SET_ACTIVE_MARKET, {
    market: market
  });
};
var setFetchPending = function setFetchPending() {
  return {
    type: MARKET_FETCH_CONFIG_PENDING
  };
};
var fetchMarketConfig = function fetchMarketConfig(market) {
  var meta = {
    market: market
  };
  var timeout = getEnv__default['default']('MARKET_REQUEST_TIMEOUT') || 1000;
  var appVersion = getWebviewAppVersion();
  var headers = _objectSpread__default['default']({
    'x-app-id': getEnv__default['default']('APP'),
    'x-market-id': market
  }, appVersion && {
    'x-cs-app-version': appVersion
  });
  return createAction__default['default'](MARKET_FETCH_CONFIG, createRequestPayload__default['default']('international', '/render-engine-local/v1/config', 'get', null, meta, headers, timeout));
};
var fetchStaticMarketConfig = function fetchStaticMarketConfig(market) {
  return createAction__default['default'](MARKET_FETCH_STATIC_CONFIG, _objectSpread__default['default'](_objectSpread__default['default']({}, createRequestPayload__default['default']('renderEngine', "".concat(market, ".json?version=").concat(getEnv__default['default']("".concat(market.toUpperCase(), "_VERSION")) || '1'))), {}, {
    market: market
  }));
};
var setActiveLocale = function setActiveLocale(activeLocale) {
  return createAction__default['default'](MARKET_SET_ACTIVE_LOCALE, activeLocale);
};
var getCurrentMarketDetails = function getCurrentMarketDetails() {
  var sessionToken = cjs$2.getSessionCookie();
  var marketSessionToken = cjs$5.resolveProp('market', sessionToken);
  var localeSessionToken = cjs$5.resolveProp('locale', sessionToken);
  return {
    marketSessionToken: marketSessionToken,
    localeSessionToken: localeSessionToken
  };
};
var getActiveMarket$1 = function getActiveMarket$1() {
  var _getCurrentMarketDeta = getCurrentMarketDetails(),
    marketSessionToken = _getCurrentMarketDeta.marketSessionToken;
  return marketSessionToken || lib_config_i18n.GLOBAL;
};
var getActiveLocale$1 = function getActiveLocale$1() {
  var _getCurrentMarketDeta2 = getCurrentMarketDetails(),
    marketSessionToken = _getCurrentMarketDeta2.marketSessionToken,
    localeSessionToken = _getCurrentMarketDeta2.localeSessionToken;
  if (localeSessionToken) return localeSessionToken;
  if (marketSessionToken) return "en-".concat(marketSessionToken);
  return lib_config_i18n.EN_GB;
};
var helpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getActiveMarket: getActiveMarket$1,
  getActiveLocale: getActiveLocale$1
});
var initialState = function initialState() {
  return {
    checkStatus: requestStatuses__namespace.INITIAL,
    fetchStatus: requestStatuses__namespace.INITIAL,
    activeMarket: getActiveMarket$1(),
    activeLocale: getActiveLocale$1(),
    markets: lib_config_i18n.MARKETS,
    locales: lib_config_i18n.LOCALES
  };
};
var domain$1 = function domain$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case MARKET_FETCH_CONFIG:
    case MARKET_FETCH_CONFIG_PENDING: // allow core to be aware of pending updates, without re-fetching the config
    case MARKET_FETCH_STATIC_CONFIG:
      return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
        fetchStatus: requestStatuses__namespace.PENDING
      });
    case MARKET_FETCH_CONFIG_SUCCESS:
    case MARKET_FETCH_STATIC_CONFIG_SUCCESS:
      return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
        fetchStatus: requestStatuses__namespace.SUCCESS
      });
    case MARKET_FETCH_CONFIG_ERROR:
      return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
        fetchStatus: requestStatuses__namespace.ERROR
      });
    case MARKET_SET_ACTIVE_MARKET:
      {
        return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
          activeMarket: payload && payload.market || initialState().activeMarket,
          activeLocale: payload && "en-".concat(payload.market) || initialState().activeLocale
        });
      }
    case MARKET_SET_ACTIVE_LOCALE:
      return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
        activeLocale: payload || initialState().activeLocale
      });
    case MARKET_SET_LOCALES:
      return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
        locales: payload || initialState().locales
      });
    case MARKET_SET_MARKETS:
      return _objectSpread__default['default'](_objectSpread__default['default']({}, state), {}, {
        markets: payload || initialState().markets
      });
    default:
      return state;
  }
};

/* eslint-disable import/prefer-default-export */
var domain = domain$1;
var resolveFetchStatus = function resolveFetchStatus(state) {
  return resolveRequest__default['default'](state, 'market.fetchStatus');
};
var marketGetFetchStatus = reselect.createSelector(resolveFetchStatus, function (fetchStatus) {
  return cjs$1.getRequestStatus(fetchStatus);
});
var getCheckStatus = function getCheckStatus(state) {
  return resolveRequest__default['default'](state, 'market.checkStatus');
};
var marketGetPredicate = reselect.createSelector(getCheckStatus, marketGetFetchStatus, function (checkStatus, fetchStatus) {
  return {
    check: cjs$1.getRequestStatus(checkStatus),
    fetch: fetchStatus
  };
});
var marketsSelector = function marketsSelector(state) {
  return cjs$5.resolveProp('market.markets', state);
};
var marketGetMarkets = reselect.createSelector(marketsSelector, function (markets) {
  return markets;
});
var activeMarketSelector = function activeMarketSelector(state) {
  return cjs$5.resolveProp('market.activeMarket', state);
};
var marketGetActiveMarket = reselect.createSelector(activeMarketSelector, function (activeMarket) {
  return activeMarket;
});
var localesSelector = function localesSelector(state) {
  return cjs$5.resolveProp('market.locales', state);
};
var marketGetLocales = reselect.createSelector(localesSelector, function () {
  var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return locales;
});
var legacyMap = {
  uk: 'en-gb',
  za: 'en-za'
};
var localeSelector = function localeSelector() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return state.locale;
};
var getActiveLanguage = function getActiveLanguage() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (locale && locale.languages || []).find(function (copy) {
    return copy.active === true;
  });
};
var getLegacyLanguageCode = reselect.createSelector(localeSelector, function (locale) {
  var activeLanguage = getActiveLanguage(locale) || {};
  var activeLocale = activeLanguage.languageCode || activeLanguage.code;
  return legacyMap[activeLocale] || activeLocale || 'en-gb';
});
var activeLocaleSelector = function activeLocaleSelector(state) {
  return cjs$5.resolveProp('market.activeLocale', state);
};
var marketGetActiveLocale = reselect.createSelector(activeLocaleSelector, marketGetLocales, getLegacyLanguageCode, function () {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var locales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var legacyLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return locales.find(function (item) {
    return item === locale;
  }) || legacyLocale || 'en-gb';
});
var marketGetConfig = reselect.createSelector(marketGetActiveMarket, function (activeMarket) {
  return function (marketConfig) {
    return marketConfig[activeMarket] || marketConfig.gb || {};
  };
});
var getResolution$1 = function getResolution$1(state) {
  return cjs$5.resolveProp('market.resolution', state) || 'ip';
};
var marketGetResolution = reselect.createSelector(getResolution$1, function (resolution) {
  return resolution;
});
var marketLegacyGetLanguage = reselect.createSelector(marketGetActiveLocale, function (locale) {
  return function (copy) {
    return copy[locale] || copy['en-gb'] || copy.uk;
  };
});
var getPredicate = marketGetPredicate;
var getFetchStatus = marketGetFetchStatus;
var getConfig = marketGetConfig;
var getMarkets = marketGetMarkets;
var getActiveMarket = marketGetActiveMarket;
var getLocales = marketGetLocales;
var getActiveLocale = marketGetActiveLocale;
var getResolution = marketGetResolution;
var getLegacyLanguage = marketLegacyGetLanguage;
var actions = {
  setActiveLocale: setActiveLocale,
  setActiveMarket: setActiveMarket,
  setMarkets: setMarkets,
  setLocales: setLocales,
  setMarketsEnvs: setMarketsEnvs,
  fetchMarketConfig: fetchMarketConfig,
  setFetchPending: setFetchPending,
  fetchStaticMarketConfig: fetchStaticMarketConfig
};
var types = {
  MARKET_SET_ACTIVE_LOCALE: MARKET_SET_ACTIVE_LOCALE,
  MARKET_SET_ACTIVE_MARKET: MARKET_SET_ACTIVE_MARKET,
  MARKET_SET_MARKETS: MARKET_SET_MARKETS,
  MARKET_SET_LOCALES: MARKET_SET_LOCALES,
  MARKET_SET_ENVS: MARKET_SET_ENVS,
  MARKET_FETCH_CONFIG: MARKET_FETCH_CONFIG,
  MARKET_FETCH_CONFIG_PENDING: MARKET_FETCH_CONFIG_PENDING,
  MARKET_FETCH_CONFIG_ERROR: MARKET_FETCH_CONFIG_ERROR,
  MARKET_FETCH_CONFIG_SUCCESS: MARKET_FETCH_CONFIG_SUCCESS,
  MARKET_FETCH_STATIC_CONFIG: MARKET_FETCH_STATIC_CONFIG,
  MARKET_FETCH_STATIC_CONFIG_ERROR: MARKET_FETCH_STATIC_CONFIG_ERROR,
  MARKET_FETCH_STATIC_CONFIG_SUCCESS: MARKET_FETCH_STATIC_CONFIG_SUCCESS
};
/* export for backward compatibility, however these should be imported directly 
from @clearscore-group/lib.config.i18n */
var constants = {
  GB: lib_config_i18n.GB,
  ZA: lib_config_i18n.ZA,
  GLOBAL: lib_config_i18n.GLOBAL,
  MARKETS: lib_config_i18n.MARKETS,
  EN_GB: lib_config_i18n.EN_GB,
  EN_ZA: lib_config_i18n.EN_ZA,
  LOCALES: lib_config_i18n.LOCALES
};
var reducers = {
  domain: domain
};
var selectors = {
  getFetchStatus: getFetchStatus,
  getPredicate: getPredicate,
  getConfig: getConfig,
  getLocales: getLocales,
  getMarkets: getMarkets,
  getActiveMarket: getActiveMarket,
  getActiveLocale: getActiveLocale,
  getResolution: getResolution,
  getLegacyLanguage: getLegacyLanguage
};
var actions_1 = actions;
var constants_1 = constants;
var helpers_1 = helpers;
var reducers_1 = reducers;
var selectors_1 = selectors;
var types_1 = types;
var cjs = /*#__PURE__*/Object.defineProperty({
  actions: actions_1,
  constants: constants_1,
  helpers: helpers_1,
  reducers: reducers_1,
  selectors: selectors_1,
  types: types_1
}, '__esModule', {
  value: true
});
var reactRedux = /*@__PURE__*/getAugmentedNamespace(reactRedux$1);
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var deepmerge__default = /*#__PURE__*/_interopDefaultLegacy(cjs$8);
var isObject = function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
};
var ignoreArrays = function ignoreArrays(_, source) {
  return source;
};
var useLanguage = function useLanguage(language, forceLocale) {
  if (!language || !isObject(language)) throw new Error('A language object must be provided');
  var activeLocale = reactRedux.useSelector(cjs.selectors.getActiveLocale);
  var locale = forceLocale || activeLocale;
  if (language[locale]) {
    return language[lib_config_i18n.EN_GB] ? deepmerge__default['default'](language[lib_config_i18n.EN_GB], language[locale], {
      arrayMerge: ignoreArrays
    }) : language[locale];
  }
  return language[lib_config_i18n.EN_GB] || null;
};
var _default = useLanguage;
var styles$2 = {
  "component": "component--U-TRW",
  "isActive": "isActive--dX4dj"
};
var Type = {
  BUTTON: 'button',
  SUBMIT: 'submit'
};
var Tag = {
  BUTTON: 'button',
  DIV: 'div'
};
var ClickableIcon = function ClickableIcon(_ref6) {
  var _ref6$type = _ref6.type,
    _type = _ref6$type === void 0 ? Type.BUTTON : _ref6$type,
    _ref6$name = _ref6.name,
    _name = _ref6$name === void 0 ? undefined : _ref6$name,
    onClick = _ref6.onClick,
    children = _ref6.children,
    _ref6$isActive = _ref6.isActive,
    _isActive = _ref6$isActive === void 0 ? false : _ref6$isActive,
    _ref6$isDisabled = _ref6.isDisabled,
    _isDisabled = _ref6$isDisabled === void 0 ? false : _ref6$isDisabled,
    _ref6$dataId = _ref6.dataId,
    _dataId = _ref6$dataId === void 0 ? undefined : _ref6$dataId,
    _ref6$tag = _ref6.tag,
    _tag = _ref6$tag === void 0 ? Tag.BUTTON : _ref6$tag,
    ariaLabel = _ref6.ariaLabel;
  if (_tag === Tag.DIV) {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles$2.component, _defineProperty({}, styles$2.isActive, _isActive)),
      onClick: onClick,
      "data-id": _dataId,
      "data-qa": "clickable-icon",
      role: "button",
      tabIndex: 0
    }, children);
  }
  return /*#__PURE__*/React.createElement("button", {
    className: classnames(styles$2.component, _defineProperty({}, styles$2.isActive, _isActive)),
    onClick: onClick,
    "data-id": _dataId,
    "data-qa": "clickable-icon",
    name: _name
    // eslint-disable-next-line react/button-has-type
    ,

    type: _type,
    disabled: _isDisabled,
    "aria-label": ariaLabel
  }, children);
};
ClickableIcon.Type = Type;
ClickableIcon.Tag = Tag;
var styles$1 = {
  "appStoreLogo": "appStoreLogo--bbsEi",
  "playStoreLogo": "playStoreLogo--Ll3UK"
};
var language = {
  playStoreAlt: 'Get it on Google Play',
  appStoreAlt: 'Download on the App Store'
};
var lang = (_lang = {}, _defineProperty(_lang, EN_GB, _objectSpread({}, language)), _defineProperty(_lang, EN_ZA, _objectSpread({}, language)), _defineProperty(_lang, EN_AU, _objectSpread({}, language)), _lang);
var APP_CTA_EVENT = 'fe_homepage_app_cta_clicked';
var useWebsiteTracking$1 = function useWebsiteTracking$1() {
  var track = useWebsiteTracking$2();
  return {
    trackAppStoreClick: function trackAppStoreClick(_ref7) {
      var panel = _ref7.panel,
        appPlatform = _ref7.appPlatform;
      var _ref8 = panel !== null && panel !== void 0 ? panel : {},
        type = _ref8.type,
        position = _ref8.position,
        _ref8$props = _ref8.props,
        props = _ref8$props === void 0 ? {} : _ref8$props;
      var _props$language = props.language,
        language = _props$language === void 0 ? {} : _props$language;
      return track({
        name: APP_CTA_EVENT,
        props: {
          module_position: position,
          panel_header_copy: language.heading,
          panel_body_copy: language.blurb || language.educational,
          module_type: "".concat(type, "-panel"),
          app_platform: appPlatform,
          e: APP_CTA_EVENT
        }
      });
    }
  };
};
var AppStoreLogo = 'https://images.ctfassets.net/8qiqw3a16vjh/1rqscicT3h3PEJnAr8vtqp/8cf609fe72bb08a5f48f6aa0faa543d1/app_store.png';
var PlayStoreLogo = 'https://images.ctfassets.net/8qiqw3a16vjh/hGdvheNzfrVKhZrIIspn0/aeda43593914d173d6987c7458cfdb95/google_play.png';
var PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android'
};
var AppStoreLogos = function AppStoreLogos(_ref9) {
  var panel = _ref9.panel,
    appStoreConfig = _ref9.appStoreConfig;
  var _useWebsiteTracking$ = useWebsiteTracking$1(),
    trackAppStoreClick = _useWebsiteTracking$.trackAppStoreClick;
  var language = _default(lang);
  var googlePlayUrl = appStoreConfig.googlePlayUrl,
    appStoreUrl = appStoreConfig.appStoreUrl,
    appStoreLink = appStoreConfig.appStoreLink,
    playStoreLink = appStoreConfig.playStoreLink,
    appleStoreToggle = appStoreConfig.appleStoreToggle,
    googleStoreToggle = appStoreConfig.googleStoreToggle;
  return /*#__PURE__*/React.createElement(Fragment, null, appleStoreToggle && /*#__PURE__*/React.createElement("div", {
    className: styles$1.appStoreLogo
  }, /*#__PURE__*/React.createElement(ClickableIcon, {
    "data-id": "appStoreLogo",
    onClick: function onClick() {
      return trackAppStoreClick({
        panel: panel,
        appPlatform: PLATFORMS.IOS
      });
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: appStoreUrl || appStoreLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Image, {
    contained: true,
    src: AppStoreLogo,
    alt: language.appStoreAlt
  })))), googleStoreToggle && /*#__PURE__*/React.createElement("div", {
    className: styles$1.playStoreLogo
  }, /*#__PURE__*/React.createElement(ClickableIcon, {
    "data-id": "playStoreLogo",
    onClick: function onClick() {
      return trackAppStoreClick({
        panel: panel,
        appPlatform: PLATFORMS.ANDROID
      });
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: googlePlayUrl || playStoreLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Image, {
    contained: true,
    src: PlayStoreLogo,
    alt: language.playStoreAlt
  })))));
};
var aboutUs = "About us";
var addressLabel = "Address";
var addressLinesAU = {
  "0": "Level 17, 383 Kent Street",
  "1": "Sydney NSW 2000, Australia"
};
var addressLinesCA = {
  "0": "Registered office at 199 Bay Street",
  "1": "Toronto, Ontario, Canada",
  "2": "M5L 1A9"
};
var addressLinesNZ = {
  "0": "Registered office at Level 4, 152 Fanshawe Street",
  "1": "Auckland, New Zealand",
  "2": "1010"
};
var addressLinesGB = {
  "0": "Vox Studios, VG 203",
  "1": "1-45 Durham Street",
  "2": "London, SE11 5JH, UK"
};
var addressLinesZA = {
  "0": "Central Office Park No 4,",
  "1": "257 Jean Avenue, Centurion, 0157",
  "2": "South Africa"
};
var antiSlavery = "Anti Modern Slavery Statement";
var auxiliaryTextAU = {
  "0": "ClearScore Australia Pty Ltd",
  "1": "ABN 21624386330",
  "2": "ACN 624386330",
  "3": "Australian Credit Licence 520783"
};
var auxiliaryTextNZ = {
  "0": "ClearScore NZ Limited",
  "1": "company number 8713780",
  "2": "NZBN: 9429051266707",
  "3": "registered in Auckland"
};
var auxiliaryTextCA = {
  "0": "ClearScore Canada Limited",
  "1": "Company number 1000038809,",
  "2": "registered in Ontario"
};
var auxiliaryTextGB = {
  "0": "Registered in England and Wales",
  "1": "Company number 09221862",
  "2": "ICO ZA100119",
  "3": "VAT registration number 255 8953 58",
  "4": "Authorised and Regulated by the Financial Conduct Authority (FRN: 654446)"
};
var auxiliaryTextZA = {
  "0": "Clearscore (PTY) Limited",
  "1": "Company registered in South Africa",
  "2": "NCR Authorised (NCRCB028)"
};
var carFinance = "Car finance";
var careers = "Careers";
var clearScoreAU = "ClearScore Australia";
var clearScoreCA = "ClearScore Canada";
var clearScoreDisclaimer = "Clear Score Technology Ltd. is an independent credit broker, not a lender. We will receive a commission if you take out a product, but we never rank offers based on that.";
var clearScoreGB = "ClearScore UK";
var clearScoreZA = "ClearScore South Africa";
var copyright = "© ClearScore Technology Ltd. All Rights Reserved.";
var createAccount = "Create account";
var creditCards = "Credit cards";
var creditScores = "Credit score & report";
var easterEggAU = "Hand crafted with <0>♥</0> in Sydney";
var easterEggCA = "Hand crafted with <0>♥</0> in Toronto";
var easterEggGB = "Hand crafted with <0>♥</0> in London";
var easterEggZA = "Hand crafted with <0>♥</0> in Cape Town";
var easterEggNZ = "Hand crafted with <0>♥</0> in Auckland, New Zealand";
var facebook = "Facebook";
var faqs = "FAQs";
var getInTouch = "Get in touch";
var help = "Help";
var learn = "Learn";
var linkedIn = "LinkedIn";
var loans = "Loans";
var login = "Log in";
var privacy = "Privacy and Cookie Policy";
var privacyPolicy = "Privacy and Cookie Policy";
var protect = "Protect";
var savingsCalculator = "Savings calculator";
var signUp = "Sign up for free";
var siteMap = "Discover";
var social = "Social";
var terms = "Terms and Conditions";
var tnc = "Terms and Conditions";
var twitter = "Twitter";
var youtube = "YouTube";
var copyEnGb = {
  aboutUs: aboutUs,
  addressLabel: addressLabel,
  addressLinesAU: addressLinesAU,
  addressLinesCA: addressLinesCA,
  addressLinesNZ: addressLinesNZ,
  addressLinesGB: addressLinesGB,
  addressLinesZA: addressLinesZA,
  antiSlavery: antiSlavery,
  auxiliaryTextAU: auxiliaryTextAU,
  auxiliaryTextNZ: auxiliaryTextNZ,
  auxiliaryTextCA: auxiliaryTextCA,
  auxiliaryTextGB: auxiliaryTextGB,
  auxiliaryTextZA: auxiliaryTextZA,
  carFinance: carFinance,
  careers: careers,
  clearScoreAU: clearScoreAU,
  clearScoreCA: clearScoreCA,
  clearScoreDisclaimer: clearScoreDisclaimer,
  clearScoreGB: clearScoreGB,
  clearScoreZA: clearScoreZA,
  copyright: copyright,
  createAccount: createAccount,
  creditCards: creditCards,
  creditScores: creditScores,
  easterEggAU: easterEggAU,
  easterEggCA: easterEggCA,
  easterEggGB: easterEggGB,
  easterEggZA: easterEggZA,
  easterEggNZ: easterEggNZ,
  facebook: facebook,
  faqs: faqs,
  getInTouch: getInTouch,
  help: help,
  learn: learn,
  linkedIn: linkedIn,
  loans: loans,
  login: login,
  privacy: privacy,
  privacyPolicy: privacyPolicy,
  protect: protect,
  savingsCalculator: savingsCalculator,
  signUp: signUp,
  siteMap: siteMap,
  social: social,
  terms: terms,
  tnc: tnc,
  twitter: twitter,
  youtube: youtube
};
var configs = (_configs = {}, _defineProperty(_configs, GB, {
  internalLinks: [{
    name: 'careers',
    href: 'https://www.clearscore.com/careers',
    target: '_blank'
  }, {
    name: 'signUp',
    href: 'https://app.clearscore.com/signup'
  }, {
    name: 'login',
    href: 'https://app.clearscore.com/login'
  }, {
    name: 'creditScores',
    href: 'https://www.clearscore.com/credit-scores'
  }, {
    name: 'creditCards',
    href: 'https://www.clearscore.com/credit-cards'
  }, {
    name: 'loans',
    href: 'https://www.clearscore.com/loans'
  }, {
    name: 'carFinance',
    href: 'https://www.clearscore.com/car-finance'
  }, {
    name: 'learn',
    href: 'https://www.clearscore.com/learn'
  }, {
    name: 'protect',
    href: 'https://www.clearscore.com/protect'
  }, {
    name: 'help',
    href: 'https://help.clearscore.com/hc/en-us'
  }, {
    name: 'clearScoreAU',
    href: 'https://www.clearscore.com/au'
  }, {
    name: 'clearScoreZA',
    href: 'https://www.clearscore.com/za'
  }, {
    name: 'clearScoreCA',
    href: 'https://www.clearscore.com/ca'
  }],
  socialLinks: [{
    name: 'facebook',
    href: 'https://www.facebook.com/clearscore/',
    newTab: true
  }, {
    name: 'twitter',
    href: 'https://twitter.com/clearscore/',
    newTab: true
  }, {
    name: 'youtube',
    href: 'https://www.youtube.com/clearscore/',
    newTab: true
  }, {
    name: 'linkedIn',
    href: 'https://www.linkedin.com/company/clearscore/',
    newTab: true
  }],
  legalLinks: [{
    name: 'privacyPolicy',
    href: 'https://www.clearscore.com/privacy-policy'
  }, {
    name: 'terms',
    href: 'https://www.clearscore.com/terms'
  }, {
    name: 'antiSlavery',
    href: 'https://media.clearscore.com/gb/docs/anti_modern_slavery_statement/1/anti_modern_slavery_statement.pdf'
  }],
  easterEgg: 'easterEggGB',
  addressLines: [copyEnGb.addressLinesGB[0], copyEnGb.addressLinesGB[1], copyEnGb.addressLinesGB[2]],
  auxiliaryText: [copyEnGb.auxiliaryTextGB[0], copyEnGb.auxiliaryTextGB[1], copyEnGb.auxiliaryTextGB[2], copyEnGb.auxiliaryTextGB[3], copyEnGb.auxiliaryTextGB[4]],
  hasClearScoreDisclaimer: true
}), _defineProperty(_configs, ZA, {
  internalLinks: [{
    name: 'signUp',
    href: 'https://app.clearscore.com/signup'
  }, {
    name: 'login',
    href: 'https://app.clearscore.com/login'
  }, {
    name: 'creditScores',
    href: 'https://www.clearscore.com/za/credit-scores'
  }, {
    name: 'creditCards',
    href: 'https://www.clearscore.com/za/credit-cards'
  }, {
    name: 'loans',
    href: 'https://www.clearscore.com/za/loans'
  }, {
    name: 'learn',
    href: 'https://www.clearscore.com/za/learn'
  }, {
    name: 'getInTouch',
    href: 'https://contact.clearscore.co.za/hc/en-us'
  }, {
    name: 'clearScoreGB',
    href: 'https://www.clearscore.com'
  }, {
    name: 'clearScoreAU',
    href: 'https://www.clearscore.com/au'
  }, {
    name: 'clearScoreCA',
    href: 'https://www.clearscore.com/ca'
  }],
  socialLinks: [{
    name: 'facebook',
    href: 'https://www.facebook.com/ClearScore-SA-1863993373838683/',
    newTab: true
  }, {
    name: 'youtube',
    href: 'https://www.youtube.com/clearscore/',
    newTab: true
  }],
  legalLinks: [{
    name: 'privacyPolicy',
    href: 'https://www.clearscore.com/za/privacy-policy'
  }, {
    name: 'terms',
    href: 'https://www.clearscore.com/za/terms'
  }],
  playStoreLink: 'https://play.google.com/store/apps/details?id=com.clearscore.mobile&hl=en_ZA',
  hasClearScoreDisclaimer: false,
  easterEgg: 'easterEggZA',
  addressLines: [copyEnGb.addressLinesZA[0], copyEnGb.addressLinesZA[1], copyEnGb.addressLinesZA[2]],
  auxiliaryText: [copyEnGb.auxiliaryTextZA[0], copyEnGb.auxiliaryTextZA[1], copyEnGb.auxiliaryTextZA[2]]
}), _defineProperty(_configs, AU, {
  internalLinks: [{
    name: 'signUp',
    href: 'https://app.clearscore.com/signup'
  }, {
    name: 'login',
    href: 'https://app.clearscore.com/login'
  }, {
    name: 'creditScores',
    href: 'https://www.clearscore.com/au/credit-scores'
  }, {
    name: 'creditCards',
    href: 'https://www.clearscore.com/au/credit-cards'
  }, {
    name: 'loans',
    href: 'https://www.clearscore.com/au/personal-loans'
  }, {
    name: 'learn',
    href: 'https://www.clearscore.com/au/learn'
  }, {
    name: 'getInTouch',
    href: 'https://contact.clearscore.com.au/hc/en-us'
  }, {
    name: 'clearScoreGB',
    href: 'https://www.clearscore.com'
  }, {
    name: 'clearScoreZA',
    href: 'https://www.clearscore.com/za'
  }, {
    name: 'clearScoreCA',
    href: 'https://www.clearscore.com/ca'
  }],
  socialLinks: [{
    name: 'facebook',
    href: 'https://www.facebook.com/ClearScore-Australia-105684634304415/',
    newTab: true
  }, {
    name: 'twitter',
    href: 'https://twitter.com/ClearScoreAU',
    newTab: true
  }, {
    name: 'youtube',
    href: 'https://www.youtube.com/clearscore/',
    newTab: true
  }, {
    name: 'linkedIn',
    href: 'https://www.linkedin.com/company/clearscore/',
    newTab: true
  }],
  legalLinks: [{
    name: 'privacyPolicy',
    href: 'https://www.clearscore.com/au/privacy-policy'
  }, {
    name: 'terms',
    href: 'https://www.clearscore.com/au/terms'
  }],
  hasClearScoreDisclaimer: false,
  easterEgg: 'easterEggAU',
  addressLines: [copyEnGb.addressLinesAU[0], copyEnGb.addressLinesAU[1]],
  auxiliaryText: [copyEnGb.auxiliaryTextAU[0], copyEnGb.auxiliaryTextAU[1], copyEnGb.auxiliaryTextAU[2], copyEnGb.auxiliaryTextAU[3]]
}), _defineProperty(_configs, CA, {
  internalLinks: [{
    name: 'signUp',
    href: 'https://app.clearscore.com/signup'
  }, {
    name: 'login',
    href: 'https://app.clearscore.com/login'
  }, {
    name: 'creditScores',
    href: 'https://www.clearscore.com/ca/credit-scores'
  }, {
    name: 'creditCards',
    href: 'https://www.clearscore.com/ca/credit-cards'
  }, {
    name: 'protect',
    href: 'https://www.clearscore.com/ca/protect'
  }, {
    name: 'clearScoreGB',
    href: 'https://www.clearscore.com'
  }, {
    name: 'clearScoreAU',
    href: 'https://www.clearscore.com/au'
  }, {
    name: 'clearScoreZA',
    href: 'https://www.clearscore.com/za'
  }],
  socialLinks: [{
    name: 'facebook',
    href: 'https://business.facebook.com/ClearScoreCA/?business_id=1760587860884478',
    newTab: true
  }, {
    name: 'twitter',
    href: 'https://twitter.com/clearscoreca',
    newTab: true
  }, {
    name: 'youtube',
    href: 'https://www.youtube.com/clearscore/',
    newTab: true
  }, {
    name: 'linkedIn',
    href: 'https://www.linkedin.com/company/clearscore/',
    newTab: true
  }],
  legalLinks: [{
    name: 'privacyPolicy',
    href: 'https://www.clearscore.com/ca/privacy-policy'
  }, {
    name: 'terms',
    href: 'https://www.clearscore.com/ca/terms'
  }],
  hasClearScoreDisclaimer: false,
  easterEgg: 'easterEggCA',
  addressLines: [copyEnGb.addressLinesCA[0], copyEnGb.addressLinesCA[1], copyEnGb.addressLinesCA[2]],
  auxiliaryText: [copyEnGb.auxiliaryTextCA[0], copyEnGb.auxiliaryTextCA[1], copyEnGb.auxiliaryTextCA[2]]
}), _defineProperty(_configs, NZ, {
  internalLinks: [{
    name: 'signUp',
    href: 'https://app.clearscore.com/signup'
  }, {
    name: 'login',
    href: 'https://app.clearscore.com/login'
  }, {
    name: 'getInTouch',
    href: 'https://help.clearscore.nz/hc/en-gb'
  }, {
    name: 'clearScoreAU',
    href: 'https://www.clearscore.com/au'
  }, {
    name: 'clearScoreGB',
    href: 'https://www.clearscore.com'
  }, {
    name: 'clearScoreZA',
    href: 'https://www.clearscore.com/za'
  }, {
    name: 'clearScoreCA',
    href: 'https://www.clearscore.com/ca'
  }],
  socialLinks: [{
    name: 'facebook',
    href: 'https://www.facebook.com/ClearScore-Australia-105684634304415/',
    newTab: true
  }, {
    name: 'twitter',
    href: 'https://twitter.com/ClearScoreAU',
    newTab: true
  }, {
    name: 'youtube',
    href: 'https://www.youtube.com/clearscore/',
    newTab: true
  }, {
    name: 'linkedIn',
    href: 'https://www.linkedin.com/company/clearscore/',
    newTab: true
  }],
  legalLinks: [{
    name: 'privacyPolicy',
    href: 'https://help.clearscore.nz/hc/en-gb/articles/11614545891090-Privacy-policy-'
  }, {
    name: 'terms',
    href: 'https://help.clearscore.nz/hc/en-gb/articles/11614452854674-Terms-and-conditions-'
  }],
  hasClearScoreDisclaimer: false,
  easterEgg: 'easterEggNZ',
  addressLines: [copyEnGb.addressLinesNZ[0], copyEnGb.addressLinesNZ[1]],
  auxiliaryText: [copyEnGb.auxiliaryTextNZ[0], copyEnGb.auxiliaryTextNZ[1], copyEnGb.auxiliaryTextNZ[2], copyEnGb.auxiliaryTextNZ[3]]
}), _configs);
var styles = {
  "footer": "footer--Pkwet",
  "background": "background--OcF-9",
  "footerTop": "footerTop--4oHyD",
  "heading": "heading--totvY",
  "logo": "logo--6I7Sk",
  "easterEgg": "easterEgg--zAONt",
  "spacing": "spacing--iZUBt",
  "links": "links--6Dav3",
  "link": "link--T8uGH",
  "logoContainer": "logoContainer--Cr2GQ",
  "addressContainer": "addressContainer--VcSKY",
  "socialLinks": "socialLinks--0Npwu",
  "siteMap": "siteMap--XyLi8",
  "topSpacing": "topSpacing--kaRbR",
  "footerBottom": "footerBottom--d8nll",
  "footerAppLogos": "footerAppLogos--f8Bi3"
};
var FOOTER_LINK_EVENT = 'fe_website_footer_link_clicked';
var useWebsiteTracking = function useWebsiteTracking() {
  var track = useWebsiteTracking$2();
  return {
    trackFooterLinkClick: function trackFooterLinkClick(_ref10) {
      var href = _ref10.href,
        label = _ref10.label,
        e = _ref10.e,
        isNewTab = _ref10.isNewTab;
      if (e && !isNewTab) e.preventDefault();
      return track({
        name: FOOTER_LINK_EVENT,
        props: {
          url: href,
          label: label,
          e: FOOTER_LINK_EVENT
        },
        onComplete: function onComplete() {
          if (!isNewTab) window.location.assign(href);
        }
      });
    }
  };
};
var COMPONENT_NAMESPACE = 'footer';
var FOOTER_ID = 'footer';
var Links = function Links(_ref11) {
  var links = _ref11.links,
    trackLinkClick = _ref11.trackLinkClick;
  var _useTranslation = useTranslation(COMPONENT_NAMESPACE),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("ul", {
    className: styles.links
  }, links.map(function (_ref12) {
    var href = _ref12.href,
      name = _ref12.name,
      newTab = _ref12.newTab;
    return /*#__PURE__*/React.createElement("li", {
      className: styles.link,
      key: name
    }, /*#__PURE__*/React.createElement(Text.Link, {
      href: href,
      theme: Text.Link.themes.DARK,
      isNewTab: newTab,
      onClick: function onClick(e) {
        return trackLinkClick({
          href: href,
          label: t(name),
          isNewTab: newTab,
          e: e
        });
      }
    }, t(name)));
  }));
};
var Footer = function Footer(_ref13) {
  var appStoreConfig = _ref13.appStoreConfig;
  var _useWebsiteTracking = useWebsiteTracking(),
    trackFooterLinkClick = _useWebsiteTracking.trackFooterLinkClick;
  var _useTranslation2 = useTranslation(COMPONENT_NAMESPACE),
    t = _useTranslation2.t;
  var _useMarketConfig = useMarketConfig(configs),
    hasClearScoreDisclaimer = _useMarketConfig.hasClearScoreDisclaimer,
    internalLinks = _useMarketConfig.internalLinks,
    socialLinks = _useMarketConfig.socialLinks,
    legalLinks = _useMarketConfig.legalLinks,
    easterEgg = _useMarketConfig.easterEgg,
    addressLines = _useMarketConfig.addressLines,
    auxiliaryText = _useMarketConfig.auxiliaryText;
  var trackLinkClick = function trackLinkClick(_ref14) {
    var href = _ref14.href,
      label = _ref14.label,
      e = _ref14.e,
      isNewTab = _ref14.isNewTab;
    return trackFooterLinkClick({
      href: href,
      label: label,
      e: e,
      isNewTab: isNewTab
    });
  };
  return /*#__PURE__*/React.createElement("footer", {
    id: FOOTER_ID,
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.background
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.footerTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logoContainer
  }, /*#__PURE__*/React.createElement(Logo, {
    className: styles.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.easterEgg,
    "data-qa": "easter-egg"
  }, /*#__PURE__*/React.createElement(Text.Body2, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: easterEgg,
    ns: COMPONENT_NAMESPACE,
    components: [/*#__PURE__*/React.createElement("span", {
      style: {
        color: 'red'
      }
    }, " \u2665 ")]
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.spacing
  }, auxiliaryText.map(function (text) {
    return /*#__PURE__*/React.createElement("div", {
      "data-qa": "auxiliary-text",
      key: text
    }, /*#__PURE__*/React.createElement(Text.Body2, null, text));
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.addressContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.heading
  }, /*#__PURE__*/React.createElement(Text.H3, null, t('addressLabel'))), /*#__PURE__*/React.createElement("div", {
    className: styles.topSpacing
  }, addressLines.map(function (addressLine) {
    return /*#__PURE__*/React.createElement("div", {
      "data-qa": "address-lines",
      key: addressLine
    }, /*#__PURE__*/React.createElement(Text.Body2, null, addressLine));
  }))), internalLinks.length ? /*#__PURE__*/React.createElement("div", {
    className: styles.siteMap,
    "data-qa": "siteMap"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.heading
  }, /*#__PURE__*/React.createElement(Text.H3, null, t('siteMap'))), /*#__PURE__*/React.createElement(Links, {
    links: internalLinks,
    trackLinkClick: trackLinkClick
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.socialLinks,
    "data-qa": "social"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.heading
  }, /*#__PURE__*/React.createElement(Text.H3, null, t('social'))), /*#__PURE__*/React.createElement(Links, {
    links: socialLinks,
    trackLinkClick: trackLinkClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.footerAppLogos
  }, /*#__PURE__*/React.createElement(AppStoreLogos, {
    panel: {
      type: FOOTER_ID
    },
    appStoreConfig: appStoreConfig
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.footerBottom,
    "data-qa": "footer-bottom"
  }, hasClearScoreDisclaimer && /*#__PURE__*/React.createElement(Spacer, {
    all: {
      bottom: Spacer.spacings.SMALL
    }
  }, /*#__PURE__*/React.createElement(Text.Body2, {
    "data-id": "footer-disclaimer"
  }, t('clearScoreDisclaimer'))), legalLinks.length ? /*#__PURE__*/React.createElement("div", {
    "data-qa": "legal-links"
  }, /*#__PURE__*/React.createElement(Links, {
    links: legalLinks,
    trackLinkClick: trackLinkClick
  })) : null, /*#__PURE__*/React.createElement("div", {
    "data-id": "footer-copyright",
    className: styles.topSpacing
  }, /*#__PURE__*/React.createElement(Text.Body6, null, t('copyright')))));
};
i18next.addResourceBundle(EN_GB, COMPONENT_NAMESPACE, copyEnGb);
export default Footer;